module.exports = __webpack_public_path__ + "static/media/shs-logo.bf53d129.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/Header/resources/shs-logo.svg
// module id = 3384
// module chunks = 0